import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const IActions = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.width ?? '22'}
            height={props.height ?? '21'}
            viewBox="0 0 22 21"
            fill={props.color ?? '#37474F'}
          >
            <rect
              x="3.34229"
              y="0.964844"
              width="18.382"
              height="2.00109"
              rx="1.00054"
              fill="#37474F"
            />
            <rect
              x="8.35596"
              y="6.96875"
              width="13.3687"
              height="2.00109"
              rx="1.00054"
              fill="#37474F"
            />
            <rect
              x="11.6975"
              y="12.9707"
              width="10.0266"
              height="2.00109"
              rx="1.00054"
              fill="#37474F"
            />
            <rect
              x="4.46027"
              y="4.84699"
              width="0.654909"
              height="15.0629"
              rx="0.327455"
              fill="#37474F"
              stroke="#37474F"
              strokeWidth="0.654909"
            />
            <line
              x1="0.75"
              y1="-0.75"
              x2="6.93062"
              y2="-0.75"
              transform="matrix(0.522931 0.852375 -0.862475 0.506099 0 14.0469)"
              stroke="#37474F"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <line
              x1="0.75"
              y1="-0.75"
              x2="6.93062"
              y2="-0.75"
              transform="matrix(-0.522931 0.852375 0.862475 0.506099 9.37207 14.0469)"
              stroke="#37474F"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        );
      }}
      {...props}
    />
  );
};

export default IActions;
